export function hueFromSlug(slug: string): number {
  let h = 0;
  for (let i = 0; i < slug.length; i++) h = (h * 31 + (slug.codePointAt(i) ?? 0)) >>> 0;
  return h % 360;
}
